import React from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import {connect} from "react-redux";

function SurveyPageFooter(props) {
    const {pathname} = useLocation();
    const history = useHistory();
    const surveyId = props.survey.id;

    const getFooterMessage = (pathname) => {
        if(pathname.includes("/survey/builder")) {
            return "Finished? Preview survey";
        }
        if(pathname.includes("/survey/preview")){
            return "Share your survey";
        }
        if(pathname.includes("/survey/share")){
            return "Check Results";
        }
    };

    const getFooterRedirPath = (pathname) => {
        if(pathname.includes("/survey/builder")) {
            return "/survey/preview/" + surveyId;
        }
        if(pathname.includes("/survey/preview")){
            return "/survey/share/" + surveyId;
        }
        if(pathname.includes("/survey/share")){
            return "/survey/reports/" + surveyId;
        }
    };

    const goToPath = (path) => {
        history.push(path)
    };

    if(surveyId && !pathname.includes("/survey/reports")) {
        const footerMessage = getFooterMessage(pathname);
        const footerRedirPath = getFooterRedirPath(pathname);

        return (
            <a className="questionaire__finish" href="#" onClick={(event) => {event.preventDefault();goToPath(footerRedirPath)}}>
                <span>{footerMessage} <img src="/assets/img/builder/finish.png" alt=""/></span>
            </a>
        )
    } else return (<React.Fragment/>);
}

function mapStateToProps(state) {
    const {survey} = state;
    return {survey};
}

export default connect(mapStateToProps, null)(SurveyPageFooter);